<script>
import { permissionsMixin } from '@/mixins/userPermissions';

 export default {
  mixins: [permissionsMixin],

  mounted(){
   this.setPermissions(this.auth);
  },

  methods: {
   isActive(path) {
    return this.$route.path === path;
  },
 },
};
</script>

<template>
<div class="col-xl-3 theiaStickySidebar">
<div class="card">
  <div class="card-body">
    <div class="d-flex flex-column list-group settings-list">
      
      <router-link to="/document-settings/proposal" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Proposal', 'read')">
      <i v-if="isActive('/document-settings/proposal')" class="ti ti-arrow-badge-right me-2"></i>Proposal</router-link>

      <router-link to="/document-settings/quotation" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Quotation', 'read')">
      <i v-if="isActive('/document-settings/quotation')" class="ti ti-arrow-badge-right me-2"></i>Quotation</router-link>

      <router-link to="/document-settings/proforma" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Proforma_Invoice', 'read')">
      <i v-if="isActive('/document-settings/proforma')" class="ti ti-arrow-badge-right me-2"></i>Proforma Invoice</router-link>
      
      <router-link to="/document-settings/invoice" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Invoice', 'read')">
      <i v-if="isActive('/document-settings/invoice')" class="ti ti-arrow-badge-right me-2"></i>Tax Invoice</router-link>

      <router-link to="/document-settings/sales-order" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Sales_Order', 'read')">
      <i v-if="isActive('/document-settings/sales-order')" class="ti ti-arrow-badge-right me-2"></i>Sales Order</router-link>

      <router-link to="/document-settings/sampling" class="d-inline-flex align-items-center rounded py-2 px-3" active-class="active" exact-active-class="active" v-if="getPermission('Sampling', 'read')">
      <i v-if="isActive('/document-settings/sampling')" class="ti ti-arrow-badge-right me-2"></i>Sampling Request</router-link>
     
    </div>
  </div>
</div>
</div>
</template>
